import { useMetricsTimeFilter } from '~/modules/analytics';
import { useMemo } from 'react';

interface UseOrderDateTimeProps {
  hasCampaignFilter?: boolean;
  isQueryTotal: boolean;
}

export const useOrderDateTime = ({ hasCampaignFilter, isQueryTotal }: UseOrderDateTimeProps) => {
  const { currentDates, compareCurrentDates } = useMetricsTimeFilter();

  const data = useMemo(() => {
    if (hasCampaignFilter && currentDates.alias !== 'custom' && !isQueryTotal) {
      return { currentDates, compareCurrentDates };
    }

    return {
      currentDates: {
        ...currentDates,
        startDate: currentDates.startDate.startOf('day'),
        endDate: currentDates.endDate.endOf('day'),
        versionId: currentDates.versionId,
      },
      compareCurrentDates: compareCurrentDates
        ? {
            ...compareCurrentDates,
            startDate: compareCurrentDates.startDate.startOf('day'),
            endDate: compareCurrentDates.endDate.endOf('day'),
          }
        : compareCurrentDates,
    };
  }, [compareCurrentDates, currentDates, hasCampaignFilter, isQueryTotal]);

  return data;
};
